import React, {useState} from "react";
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalFooter,
    ModalBody,
    ModalCloseButton,
    useDisclosure,
    Lorem,
    Button
  } from '@chakra-ui/react';

export default function ModalInfo() {

    const { isOpen, onOpen, onClose } = useDisclosure()
  
    return (
        <>
        <Button onClick={onOpen}>Normas Operativas</Button>
        
        <Modal onClose={onClose} isOpen={isOpen} isCentered size={'full'}>
          <ModalOverlay />
          <ModalContent>
            <ModalHeader>Portal de Prestadores | Información</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
                <object width="100%" height="900" data="https://portaldeprestadores.hbritanicoweb.com.ar/static/NormasOperativasPSHB.pdf" type="application/pdf">   </object>
            </ModalBody>
            <ModalFooter>
              <Button onClick={onClose}>Volver</Button>
            </ModalFooter>
          </ModalContent>
        </Modal>
      </>
    )
}
